// "Install the app" popup for mobile browsers: an iOS-style sheet or an Android-style dialog,
// shown on every open until the app runs installed or the user ticks "Don't show this again".
const KEY = 'borotok.install.hidden';

// 'ios' | 'android' | null; iPadOS says "Macintosh", its touch points give it away
export function platform(ua, touchPoints = 0) {
  if (/iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && touchPoints > 1)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return null;
}

let deferred = null; // Chrome's beforeinstallprompt, when it comes
let onPrompt = () => {};
globalThis.addEventListener?.('beforeinstallprompt', e => { e.preventDefault(); deferred = e; onPrompt(); });

const SHARE = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#d4a373" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12M8 7l4-4 4 4"/><path d="M7 10H5v11h14V10h-2"/></svg>';

export function startInstallPrompt({ el, ua = navigator.userAgent, touchPoints = navigator.maxTouchPoints } = {}) {
  const os = platform(ua, touchPoints);
  const standalone = matchMedia('(display-mode: standalone)').matches || navigator.standalone;
  let hidden = false;
  try { hidden = localStorage.getItem(KEY) === '1'; } catch { /* storage blocked: show it */ }
  if (!os || standalone || hidden) return;

  const check = el('input', { type: 'checkbox', id: 'install-hide' });
  const close = () => {
    if (check.checked) try { localStorage.setItem(KEY, '1'); } catch { /* nothing to keep it in */ }
    overlay.remove();
  };
  const dontShow = el('label', { className: 'install-hide', for: 'install-hide' }, check, " Don't show this again");
  const icon = el('img', { src: '/icon-192.png', alt: '', className: 'install-icon' });
  const chip = text => el('b', { className: 'install-chip', text });
  let box;
  if (os === 'ios') {
    const share = el('span', { className: 'install-chip' }); share.innerHTML = SHARE;
    box = el('div', { className: 'install ios', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'install-title' },
      el('header', {}, icon, el('h2', { id: 'install-title', text: 'Install Borotok' })),
      el('p', { text: 'Install the app on your device to easily access it anytime. No app store. No download. No hassle.' }),
      el('ol', {},
        el('li', {}, 'Tap on ', share, ' in the Safari toolbar'),
        el('li', {}, 'Select ', chip('Add to Home Screen'))),
      dontShow,
      el('button', { className: 'install-x', 'aria-label': 'Close', text: '✕', onclick: close }));
  } else {
    const install = el('button', { className: 'install-go', text: 'Install', hidden: !deferred, onclick: async () => {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      deferred = null;
      if (outcome === 'accepted') overlay.remove();
    } });
    onPrompt = () => { install.hidden = false; };
    box = el('div', { className: 'install android', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'install-title' },
      el('h2', { id: 'install-title', text: 'Install app' }),
      el('div', { className: 'install-app' }, icon, el('div', {}, el('strong', { text: 'Borotok' }), el('small', { text: location.host }))),
      el('p', { text: 'Install the app on your device to easily access it anytime. No app store. No download. No hassle.' }),
      el('ol', {},
        el('li', {}, 'Tap ', chip('⋮'), ' in the browser’s top right corner'),
        el('li', {}, 'Select ', chip('Install app'), ' or ', chip('Add to Home screen'))),
      dontShow,
      el('div', { className: 'install-actions' }, el('button', { text: 'Cancel', onclick: close }), install));
  }
  const overlay = el('div', { className: 'install-overlay', onclick: e => { if (e.target === overlay) close(); } }, box);
  document.body.append(overlay);
}
